import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Empresa } from '../../entities/empresa';
import { Api } from '../../providers/api/api';

import * as _ from 'lodash';
import * as moment from "moment";

moment.locale('pt-BR');

interface PeriodoProducaoCorteMultiloja {
    Id: string;
    DataTransferencia: Date;
    QuantidadeCalcinha: number;
    QuantidadeSutia: number;
    QuantidadeModelador: number;
    TotalPecas: number;
    Empresa: Empresa;
}

@Component({
    selector: 'periodo-pro-corte-multilojas',
    templateUrl: './periodo-pro-corte-multilojas.html'
})
export class PeriodoProducaoCorteMultilojasComponent implements OnInit, OnDestroy {
    public hoje: string = new Date().toISOString();
    public dataInicial: string = new Date("2016-04-26").toISOString();
    public dataFinal: string = new Date().toISOString();

    @Input('analytic') analytic: boolean = false;

    public producaoCorteMultilojaDilady: any;
    public producaoCorteMultilojaLoveSecret: any;
    public producaoCorteMultilojaBanhoDeMar: any;
    public producaoCorteMultilojaGrupo: any;

    public carregandoDados: boolean = true;

    private _myInterval: number;

    constructor(
        private _api: Api
    ) { }

    public ngOnInit(): void {
        this.carregandoDados = true;
        this._separarLojas();

        if (this._myInterval)
            clearInterval(this._myInterval);

        this._myInterval = setInterval(() => {
            this._separarLojas();
        }, 30000);
    }

    public ngOnDestroy(): void {
        clearInterval(this._myInterval);
    }

    private _separarLojas(): void {
        this._obterPeriodoProducaoCorteMultiloja().then(periodosBruto => {
            let periodos = periodosBruto.filter(a => moment(a.DataTransferencia).isBetween(this.dataInicial, this.dataFinal));

            this.producaoCorteMultilojaGrupo = {
                QuantidadeCalcinha: _.sum(periodos.map(a => a.QuantidadeCalcinha)),
                QuantidadeSutia: _.sum(periodos.map(a => a.QuantidadeSutia)),
                QuantidadeModelador: _.sum(periodos.map(a => a.QuantidadeModelador))
            }
            this.producaoCorteMultilojaGrupo.TotalPecas = (this.producaoCorteMultilojaGrupo.QuantidadeModelador + this.producaoCorteMultilojaGrupo.QuantidadeSutia + this.producaoCorteMultilojaGrupo.QuantidadeCalcinha);

            let producaoCorteMultilojaDilady = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 1));
            if (producaoCorteMultilojaDilady.length > 0) {
                this.producaoCorteMultilojaDilady = {
                    QuantidadeCalcinha: _.sum(producaoCorteMultilojaDilady.map(a => a.QuantidadeCalcinha)),
                    QuantidadeSutia: _.sum(producaoCorteMultilojaDilady.map(a => a.QuantidadeSutia)),
                    QuantidadeModelador: _.sum(producaoCorteMultilojaDilady.map(a => a.QuantidadeModelador)),
                    Empresa: producaoCorteMultilojaDilady[0].Empresa
                }
                this.producaoCorteMultilojaDilady.TotalPecas = (this.producaoCorteMultilojaDilady.QuantidadeModelador + this.producaoCorteMultilojaDilady.QuantidadeSutia + this.producaoCorteMultilojaDilady.QuantidadeCalcinha);
            } else {
                this.producaoCorteMultilojaDilady = {
                    QuantidadeCalcinha: 0,
                    QuantidadeSutia: 0,
                    QuantidadeModelador: 0,
                    TotalPecas: 0,
                    Empresa: { Id: 1, Descricao: 'Dilady Lingerie' }
                }
            }

            let producaoCorteMultilojaLoveSecret = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 2));
            if (producaoCorteMultilojaLoveSecret.length > 0) {
                this.producaoCorteMultilojaLoveSecret = {
                    QuantidadeCalcinha: _.sum(producaoCorteMultilojaLoveSecret.map(a => a.QuantidadeCalcinha)),
                    QuantidadeSutia: _.sum(producaoCorteMultilojaLoveSecret.map(a => a.QuantidadeSutia)),
                    QuantidadeModelador: _.sum(producaoCorteMultilojaLoveSecret.map(a => a.QuantidadeModelador)),
                    Empresa: producaoCorteMultilojaLoveSecret[0].Empresa
                }
                this.producaoCorteMultilojaLoveSecret.TotalPecas = (this.producaoCorteMultilojaLoveSecret.QuantidadeModelador + this.producaoCorteMultilojaLoveSecret.QuantidadeSutia + this.producaoCorteMultilojaLoveSecret.QuantidadeCalcinha);
            } else {
                this.producaoCorteMultilojaLoveSecret = {
                    QuantidadeCalcinha: 0,
                    QuantidadeSutia: 0,
                    QuantidadeModelador: 0,
                    TotalPecas: 0,
                    Empresa: { Id: 2, Descricao: 'Love Secret Lingerie' }
                }
            }

            let producaoCorteMultilojaBanhoDeMar = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 3));
            if (producaoCorteMultilojaBanhoDeMar.length > 0) {
                this.producaoCorteMultilojaBanhoDeMar = {
                    QuantidadeCalcinha: _.sum(producaoCorteMultilojaBanhoDeMar.map(a => a.QuantidadeCalcinha)),
                    QuantidadeSutia: _.sum(producaoCorteMultilojaBanhoDeMar.map(a => a.QuantidadeSutia)),
                    QuantidadeModelador: _.sum(producaoCorteMultilojaBanhoDeMar.map(a => a.QuantidadeModelador)),
                    Empresa: producaoCorteMultilojaBanhoDeMar[0].Empresa
                }
                this.producaoCorteMultilojaBanhoDeMar.TotalPecas = (this.producaoCorteMultilojaBanhoDeMar.QuantidadeModelador + this.producaoCorteMultilojaBanhoDeMar.QuantidadeSutia + this.producaoCorteMultilojaBanhoDeMar.QuantidadeCalcinha);
            } else {
                this.producaoCorteMultilojaBanhoDeMar = {
                    QuantidadeCalcinha: 0,
                    QuantidadeSutia: 0,
                    QuantidadeModelador: 0,
                    TotalPecas: 0,
                    Empresa: { Id: 3, Descricao: 'Banho de Mar Acquashape' }
                }
            }

            setTimeout(() => {
                this.carregandoDados = false;
            }, 1000);
        }).catch(error => {
            console.error(error);
        });
    }

    private _obterPeriodoProducaoCorteMultiloja(): Promise<PeriodoProducaoCorteMultiloja[]> {
        return new Promise((resolve, reject) => {
            this._api.get('PeriodoProducaoCorteMultiloja').subscribe(response => resolve(JSON.parse(response._body)), reject);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/periodo-pro-corte-multilojas/periodo-pro-corte-multilojas.ts